import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/exams/$id/questions/' as never)({
  component: ExamQuestionsRedirect,
});

/** Questions are now integrated into the main edit page tabs. */
function ExamQuestionsRedirect() {
  const { id } = (Route as unknown as { useParams: () => { id: string } }).useParams();
  return <Navigate to={'/exams/$id' as never} params={{ id } as never} />;
}
